import { Checkbox } from '@digdir/designsystemet-react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CardContentWrapper } from '../../../../../solceller/form/components/styledComponents';
import { StyledCard } from '../../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { OppvarmingFormData } from '../../../../types';
import { useVedValidation } from '../useVedValidation';
import { InstallasjonsArRadio } from '../../../../../../components/installasjonsArRadio';

export const LukketOvn = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { validateVedSelection } = useVedValidation();
  const { t } = useTranslation();

  const lukketOvnSelected = watch('ved.value.lukketOvn.selected');

  return (
    <StyledCard isActive={lukketOvnSelected}>
      <CardContentWrapper>
        <Checkbox
          aria-invalid={!!formState.errors?.ved?.value?.lukketOvn?.selected}
          label={t('form.oppvarming.ved.lukketOvn.label')}
          {...register('ved.value.lukketOvn.selected', {
            validate: validateVedSelection,
            deps: ['ved.value.apenPeis.selected', 'ved.value.peisMedDor.selected'],
            shouldUnregister: true
          })}
        />
        {lukketOvnSelected && <InstallasjonsArRadio
          name={`ved.value.lukketOvn.value`}
          translationKeyPrefix={`form.oppvarming.ved.lukketOvn.installasjonsAr`}
        />}
      </CardContentWrapper>
    </StyledCard>
  );
};
